/**
 * 取り込めなかった行の表（docs/01 6-4「何行目の、どの項目が、なぜ駄目か」）。
 *
 * 理由だけで終わらせず、**どう直すか**まで1行で添える（docs/06 原則2）。
 */
import type { ReactNode } from 'react';
import type { RosterColumn, RosterRowIssue } from '../api/types.js';
import { useRoleWording } from '../auth/role-wording.js';
import { useSession } from '../auth/session-context.js';
import { fieldLabel, howToFix, reasonLabel } from '../roster/errors.js';
import { DataTable } from './ui/DataTable.js';

export function RosterErrorTable({
  issues,
  columns,
}: {
  issues: readonly RosterRowIssue[];
  columns: readonly RosterColumn[];
}): ReactNode {
  // 直し方に出す役職の呼び名は、その会社のもの（issue #480）
  const wording = useRoleWording();
  const { profile } = useSession();
  const roles = profile?.roles.roles ?? [];
  if (issues.length === 0) return <p className="admin-empty">取り込めない行はありません。</p>;

  return (
    <section>
      <h3>取り込めない行（{issues.length}件）</h3>
      <DataTable label="取り込めない行の一覧">
        <thead>
          <tr>
            <th scope="col">何行目</th>
            <th scope="col">どの項目</th>
            <th scope="col">なぜ</th>
            <th scope="col">どう直すか</th>
          </tr>
        </thead>
        <tbody>
          {issues.map((issue, index) => (
            <tr key={`${issue.lineNumber}-${issue.field ?? ''}-${index}`}>
              <th scope="row">{issue.lineNumber}行目</th>
              <td>{fieldLabel(issue.field, columns)}</td>
              <td className="ui-cell-wrap">{reasonLabel(issue)}</td>
              <td className="ui-cell-wrap">{howToFix(issue, columns, { wording, roles })}</td>
            </tr>
          ))}
        </tbody>
      </DataTable>
    </section>
  );
}
